import { IinitialCatalogCorrelationsState } from 'interfaces/catalogCorrelations.interface';

const initialCatalogCorrelationsState: IinitialCatalogCorrelationsState = {
  correlations: {
    family: [],
    color: [],
    gender: [],
    season: [],
    segmentation: [],
    division: [],
  },
  isLoading: false,
  getCatalogCorrelations: () => Promise.resolve(false),
  assignGenerics: () => Promise.resolve(false),
  isLoadingAssignGenerics: false,
};

export default initialCatalogCorrelationsState;
